import {Component, OnInit} from '@angular/core';
import {AccountService} from "../../query/account";
import {Router} from "@angular/router";
import {QueryService} from "../../query/query";
import {QueryBuilder} from "../../query/query-builder";

@Component({
  selector: 'app-label-reviews',
  templateUrl: './label-reviews.component.html',
  styleUrls: ['./label-reviews.component.scss']
})
export class LabelReviewsComponent implements OnInit {

  constructor(
    public account: AccountService, 
    private router: Router, 
    private query: QueryService
  ) { }

  public page = 1;
  public perPage = 20;
  public reviewsData: any = {};
  public reviews: any[] = [];
  public expandedOcr: { [key: number]: boolean } = {};
  public expandedJson: { [key: number]: boolean } = {};

  ngOnInit(): void {
    if (!this.account.isAuth()) {
      this.router.navigateByUrl('/login');
      return;
    }
    this.loadReviews();
  }

  loadReviews(page = 1) {
    this.page = page;
    if (this.page < 1) {
      this.page = 1;
    }

    const qb = new QueryBuilder()
      .per_page(this.perPage)
      .page(this.page)
      .with(['user'])
      .orderBy('label_review_id', 'desc');

    this.query.all('labelReview', qb).then(res => {
      this.reviewsData = res;
      this.reviews = res.data;
      
      // Parse JSON for each review
      this.reviews.forEach(review => {
        try {
          review.parsedResponse = JSON.parse(review.response_json);
        } catch (e) {
          review.parsedResponse = null;
        }
      });
    });
  }

  toggleOcr(reviewId: number) {
    this.expandedOcr[reviewId] = !this.expandedOcr[reviewId];
  }

  toggleJson(reviewId: number) {
    this.expandedJson[reviewId] = !this.expandedJson[reviewId];
  }

  truncateText(text: string, maxLength: number = 200): string {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      // Could add a toast notification here
    });
  }

  formatJson(obj: any): string {
    if (!obj) return '';
    try {
      return JSON.stringify(obj, null, 2);
    } catch (e) {
      return String(obj);
    }
  }

  getUserDisplay(user: any): string {
    if (!user) return 'Unknown';
    return user.name || user.email || `User #${user.user_id}`;
  }
}